
<template>
  <div>
    <b-navbar type="light" variant="defualt" flex-column class="site-header" toggleable="lg">
      <b-navbar-toggle class="nav-toggle"  target="#" @click="onNavToggle"></b-navbar-toggle>


      <router-link  to="#" class="brand-main">

<img
        id="logo-desk"
        src="../../../assets/logo.jpg"
        alt="Movil Euros"
        class="d-none d-md-inline"
      >
      <img
        id="logo-mobile"
        src="../../../assets/logo.jpg"
        alt="Laraspace Logo"
        class="d-md-none"
      >     </router-link>

      <b-navbar-toggle class="nav-toggle" target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto textbold">
         

         

        

       

          <b-nav-item-dropdown class="header-margin text-center margin-nav-text" center right>
            <!-- Using 'button-content' slot -->
            <template class="text-center" slot="button-content">
              <em>{{ this.userData.name }}</em>
            </template>

          
         

            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item class="dropdown" @click="logout">{{$t('log_out')}}</b-dropdown-item>
          </b-nav-item-dropdown>
         
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

  


 

    <b-modal
      v-model="isShowInfo"
      ref="simple_show_info"
      id="simple_show_info"
      :title="$t('info')"
      ok-only
    >
      <p>{{ message }}</p>
    </b-modal>
  </div>
</template>
<script >
import Auth from "../.././../services/auth";





export default {
  components: {
   
  },
  props: {
    statusAction: {
      type: Object,
      require: true,
      default: Object
    }
  },
  data() {
    return {
      isLoading: false,
      userData: "",
      message: "",
      isShowInfo: false,

    };
  },

  mounted() {

    this.userData = Auth.userData().user;
    
  },

  computed: {
    getFullPath() {
      return this.$route.path;
    }
  },
  watch: {
    getFullPath() {
     
    },
    statusAction: function(newVal) {
      setTimeout(() => {

        if (newVal.errorCode == "11") {
              
          this.message = newVal.message;
          this.isShowInfo = true;
        }
      }, 500);
    }
  },

  methods: {
    
   

    onNavToggle() {
      this.$utils.toggleSidebar();
    },
   
  
    logout() {
      Auth.logout().then(() => {
        this.$router.replace(this.$i18nRoute({ name: "login" }));
      });
    },

  }
};
</script>

<style scoped>
.dropdown-item {
  color: #fff !important;
}
.dropdown {
  color: #fff !important;
}
.navbar-collapse {
  background-color: #f8f8f8;
}

.margin-nav-text {
  margin-top: 0%;
}

.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  background-image: none !important;
}
.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  background-color: red;
}
</style>
